// Admin Media
export default function AdminMedia() { return <div><h1 className="text-3xl font-bold">Media Library</h1><p className="mt-4">Upload and manage images and files.</p></div>; }